import { t } from 'i18next';

import {
  ADD_DEFAULT_SUB_TASKS,
  ADD_DEFAULT_SUB_TASKS_FAILURE,
  ADD_DEFAULT_SUB_TASKS_SUCCESS,
  ADD_MASTER_SUBTASK,
  ADD_MASTER_SUBTASK_FAILURE,
  ADD_MASTER_SUBTASK_SUCCESS,
  ADD_SUB_TASK,
  ADD_SUB_TASK_FAILURE,
  ADD_SUB_TASK_SUCCESS,
  ADD_TASK_LOCATION,
  ADD_TASK_LOCATION_FAILURE,
  ADD_TASK_LOCATION_SUCCESS,
  CLEAR_NEW_DEFAULT_SUB_TASK,
  CREATE_TASK,
  CREATE_TASK_FAILURE,
  CREATE_TASK_SUCCESS,
  DELETE_SUB_TASK,
  DELETE_SUB_TASK_FAILURE,
  DELETE_SUB_TASK_SUCCESS,
  DELETE_TASK,
  DELETE_TASK_FAILURE,
  DELETE_TASK_SUCCESS,
  DUPLICATE_TASK,
  DUPLICATE_TASK_FAILURE,
  DUPLICATE_TASK_SUCCESS,
  EDIT_MASTER_SUBTASK,
  EDIT_MASTER_SUBTASK_FAILURE,
  EDIT_MASTER_SUBTASK_SUCCESS,
  EDIT_MASTER_TASK,
  EDIT_MASTER_TASK_FAILURE,
  EDIT_MASTER_TASK_SUCCESS,
  EDIT_SUB_TASK,
  EDIT_SUB_TASK_FAILURE,
  EDIT_SUB_TASK_SUCCESS,
  EDIT_TASK,
  EDIT_TASK_FAILURE,
  EDIT_TASK_SUCCESS,
  GET_DEFAULT_SUB_TASKS,
  GET_DEFAULT_SUB_TASKS_FAILURE,
  GET_DEFAULT_SUB_TASKS_SUCCESS,
  GET_ITEM_SUB_TASKS,
  GET_ITEM_SUB_TASKS_FAILURE,
  GET_ITEM_SUB_TASKS_SUCCESS,
  GET_MASTER_SUBTASKS,
  GET_MASTER_SUBTASKS_FAILURE,
  GET_MASTER_SUBTASKS_SUCCESS,
  GET_MASTER_TASKS,
  GET_MASTER_TASKS_FAILURE,
  GET_MASTER_TASKS_SUCCESS,
  GET_SUB_TASKS,
  GET_SUB_TASKS_FAILURE,
  GET_SUB_TASKS_SUCCESS,
  GET_SUB_TASK_EVIDENCE,
  GET_SUB_TASK_EVIDENCE_FAILURE,
  GET_SUB_TASK_EVIDENCE_SUCCESS,
  GET_TASKS_LIST,
  GET_TASKS_LIST_FAILURE,
  GET_TASKS_LIST_SUCCESS,
  GET_TASK_DETAILS,
  GET_TASK_DETAILS_FAILURE,
  GET_TASK_DETAILS_SUCCESS,
  GET_TASK_LOCATIONS,
  GET_TASK_LOCATIONS_FAILURE,
  GET_TASK_LOCATIONS_SUCCESS,
  GET_TASK_TYPE,
  GET_TASK_TYPE_FAILURE,
  GET_TASK_TYPE_SUCCESS,
  LOGIN_PROFILE_CREATED_RESET,
  UPDATE_SUB_TASK_APPROVAL,
  UPDATE_SUB_TASK_APPROVAL_FAILURE,
  UPDATE_SUB_TASK_APPROVAL_SUCCESS,
  UPDATE_TASK_STATUS,
  UPDATE_TASK_STATUS_FAILURE,
  UPDATE_TASK_STATUS_SUCCESS,
} from '../../modules/constants';
import { createNotification } from '../../modules/notificationManager';

const noInternetMsg =
  'No Internet Connection! Please connect to the internet and try again';

//get tasks list
export const getTasksListRequest = (state, action) => {
  return {
    ...state,
    isLoading: true,
  };
};
export const getTasksListRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    return {
      ...state,
      isLoading: false,
      tasksList: data.data.results,
      tasksListCount: data.data.count,
      taskListPageSize: data.data.page_size,
    };
  }
  return {
    ...state,
    isLoading: false,
    tasksList: [],
    tasksListCount: null,
    taskListPageSize: null,
  };
};
export const getTasksListRequestFailure = (state, action) => {
  return {
    ...state,
    isLoading: false,
    tasksList: [],
    tasksListCount: null,
    taskListPageSize: null,
  };
};

// create task
export const createTaskRequest = (state, action) => {
  return {
    ...state,
    isLoading: true,
  };
};
export const createTaskRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data && data.status === 201) {
    createNotification('success', t('task_created_successfully'), 2000);
    return {
      ...state,
      isLoading: false,
      createdTaskInfo: data.data,
    };
  }
  return {
    ...state,
    isLoading: false,
    createdTaskInfo: null,
  };
};
export const createTaskRequestFailure = (state, action) => {
  const {
    payload: { response },
  } = action;
  if (
    response &&
    response.status === 400 &&
    response.data &&
    response.data.detail &&
    response.data.detail === 'employee has another task within the given time'
  ) {
    createNotification(
      'error',
      t(`employee_has_another_task_within_the_given_time`),
      5000,
    );
    return {
      ...state,
      isLoading: false,
      createdTaskInfo: null,
      overlap: true,
    };
  }
  if (action.payload.data === undefined) {
    createNotification('error', 'Something went Wrong.', 3000);
    return {
      ...state,
      isLoading: false,
      createdTaskInfo: null,
    };
  }
  const {
    payload: { data },
  } = action;
  if (data.status === 400) {
    createNotification(
      'error',
      'Sorry! could not create task. Please try again.',
      2000,
    );
  }
  return {
    ...state,
    isLoading: false,
    createdTaskInfo: null,
  };
};

// Task details by id
export const getTaskDetailsRequest = (state, action) => {
  return {
    ...state,
    isLoading: true,
  };
};
export const getTaskDetailsRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    return {
      ...state,
      isLoading: false,
      taskDetails: data.data,
    };
  }
  return {
    ...state,
    isLoading: false,
    taskDetails: null,
  };
};
export const getTaskDetailsRequestFailure = (state, action) => {
  return {
    ...state,
    isLoading: false,
    taskDetails: null,
  };
};

//edit task
export const editTaskRequest = (state, action) => {
  return {
    ...state,
    isLoading: true,
    callback: false,
  };
};
export const editTaskRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data && data.status === 200) {
    createNotification('success', t('task_updated_successfully'), 2000);
    return {
      ...state,
      isLoading: false,
      callback: true,
    };
  }
  return {
    ...state,
    isLoading: false,
    callback: false,
  };
};
export const editTaskRequestFailure = (state, action) => {
  const {
    payload: { response },
  } = action;
  if (
    response &&
    response.status === 400 &&
    response.data &&
    response.data.detail &&
    response.data.detail === 'employee has another task within the given time'
  ) {
    createNotification(
      'error',
      t(`employee_has_another_task_within_the_given_time`),
      5000,
    );
    return {
      ...state,
      isLoading: false,
      callback: false,
      overlap: true,
    };
  }
  if (action.payload.data === undefined) {
    createNotification('error', 'Something went wrong!', 2000);
    return {
      ...state,
      isLoading: false,
      callback: false,
    };
  }
  const {
    payload: { data },
  } = action;
  if (data.status === 400) {
    createNotification('error', 'Failed!! please try again', 2000);
  }
  return {
    ...state,
    isLoading: false,
    callback: false,
  };
};

//add sub task Evidence
export const getSubTaskEvidenceRequest = (state, action) => {
  return {
    ...state,
    isLoading: false,
    callback: false,
  };
};
export const getSubTaskEvidenceRequestSuccess = (state, action) => {
  const {
    payload: { data, task_id, sub_task_id },
  } = action;

  if (data && data.status === 200) {
    const sub_task_evidences = data.data;
    let newList = JSON.parse(JSON.stringify(state.tasksList));
    if (state.tasksList && state.tasksList.length > 0 && task_id) {
      newList = newList.map(task => {
        if (task.id === task_id) {
          task.sub_tasks = task.sub_tasks.map(subTask => {
            if (subTask.id === sub_task_id) {
              subTask.evidences = sub_task_evidences;
            }
            return subTask;
          });
        }
        return task;
      });
    }
    return {
      ...state,
      isLoading: false,
      callback: false,
      reloadSubTask: state.reloadSubTask ? !state.reloadSubTask : true,
      tasksList: [...newList],
    };
  }
  return {
    ...state,
    isLoading: false,
    callback: false,
  };
};
export const getSubTaskEvidenceRequestFailure = (state, action) => {
  const {
    payload: { response },
  } = action;
  if (
    response &&
    response.status === 400 &&
    response.data &&
    response.data.detail
  ) {
    createNotification('error', response.data.detail, 5000);
    return {
      ...state,
      isLoading: false,
      callback: false,
      overlap: true,
    };
  }
  if (action.payload.data === undefined) {
    createNotification('error', 'Something went wrong!', 2000);
    return {
      ...state,
      isLoading: false,
      callback: false,
    };
  }
  const {
    payload: { data },
  } = action;
  if (data.status === 400) {
    createNotification('error', 'Failed!! please try again', 2000);
  }
  return {
    ...state,
    isLoading: false,
    callback: false,
  };
};

//get  sub task
export const getSubTasksRequest = (state, action) => {
  return {
    ...state,
    isLoading: true,
    callback: false,
  };
};
export const getSubTasksRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;

  if (data && data.status === 200) {
    return {
      ...state,
      isLoading: false,
      subTasksList: data.data.results,
      tasksListCount: data.data.count,
      taskListPageSize: data.data.page_size,
    };
  }
  return {
    ...state,
    isLoading: false,
    subTasksList: [],
  };
};
export const getSubTasksRequestFailure = (state, action) => {
  const {
    payload: { response },
  } = action;
  if (
    response &&
    response.status === 400 &&
    response.data &&
    response.data.detail
  ) {
    createNotification('error', response.data.detail, 5000);
    return {
      ...state,
      isLoading: false,
      subTasksList: [],
    };
  }
  if (action.payload.data === undefined) {
    createNotification('error', 'Something went wrong!', 2000);
    return {
      ...state,
      isLoading: false,
      subTasksList: [],
    };
  }
  const {
    payload: { data },
  } = action;
  if (data.status === 400) {
    createNotification('error', 'Failed!! please try again', 2000);
  }
  return {
    ...state,
    isLoading: false,
    callback: false,
  };
};

//get default sub task
export const getDefaultSubTasksRequest = (state, action) => {
  return {
    ...state,
    isLoading: false,
    callback: false,
  };
};
export const getDefaultSubTasksRequestSuccess = (state, action) => {
  const {
    payload: { data, public_zone_id },
  } = action;

  if (data && data.status === 200) {
    return {
      ...state,
      isLoading: false,
      defaultSubTasks: data.data,
    };
  }
  return {
    ...state,
    isLoading: false,
    defaultSubTasks: [],
  };
};
export const getDefaultSubTasksRequestFailure = (state, action) => {
  const {
    payload: { response },
  } = action;
  if (
    response &&
    response.status === 400 &&
    response.data &&
    response.data.detail
  ) {
    createNotification('error', response.data.detail, 5000);
    return {
      ...state,
      isLoading: false,
      defaultSubTasks: [],
    };
  }
  if (action.payload.data === undefined) {
    createNotification('error', 'Something went wrong!', 2000);
    return {
      ...state,
      isLoading: false,
      defaultSubTasks: [],
    };
  }
  const {
    payload: { data },
  } = action;
  if (data.status === 400) {
    createNotification('error', 'Failed!! please try again', 2000);
  }
  return {
    ...state,
    isLoading: false,
    callback: false,
  };
};

export const handleClearNewDefaultSubTask = (state, action) => {
  return {
    ...state,
    newDefaultSubTask: null,
  };
};

//add default sub task
export const addDefaultSubTasksRequest = (state, action) => {
  return {
    ...state,
    newDefaultSubTask: null,
    isAddDefaultSubTaskLoading: true,
    callback: false,
  };
};

export const addDefaultSubTasksRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  console.log('🚀🚀🚀🚀 ~ addDefaultSubTasksRequestSuccess ~ data:', data);

  if (data && data.status === 201) {
    const newData = state.defaultSubTasks;
    newData.push(data.data);
    console.log('-------');
    return {
      ...state,
      newDefaultSubTask: data.data,
      isAddDefaultSubTaskLoading: false,
      defaultSubTasks: [...newData],
    };
  }
  return {
    ...state,
    newDefaultSubTask: null,
    isAddDefaultSubTaskLoading: false,
  };
};
export const addDefaultSubTasksRequestFailure = (state, action) => {
  const {
    payload: { response },
  } = action;
  if (
    response &&
    response.status === 400 &&
    response.data &&
    response.data.detail
  ) {
    createNotification('error', response.data.detail, 5000);
    return {
      ...state,
      newDefaultSubTask: null,
      isAddDefaultSubTaskLoading: false,
    };
  }
  if (action.payload.data === undefined) {
    console.log(
      '🚀🚀🚀🚀 ~ addDefaultSubTasksRequestFailure ~ payload:',
      action.payload,
    );
    createNotification('error', 'Something went wrong!', 2000);
    return {
      ...state,
      newDefaultSubTask: null,
      isAddDefaultSubTaskLoading: false,
    };
  }
  const {
    payload: { data },
  } = action;
  if (data.status === 400) {
    createNotification('error', 'Failed!! please try again', 2000);
  }
  return {
    ...state,
    isAddDefaultSubTaskLoading: false,
    callback: false,
  };
};

//add sub task
export const addSubTaskRequest = (state, action) => {
  return {
    ...state,
    isLoading: false,
    callback: false,
  };
};
export const addSubTaskRequestSuccess = (state, action) => {
  const {
    payload: { data, task_id },
  } = action;

  if (data && data.status === 201) {
    const sub_task_data = data.data;
    createNotification('success', 'Sub Task added successfully', 2000);
    let newList = state.tasksList;
    if (state.tasksList && state.tasksList.length > 0 && task_id) {
      newList = newList.map(task => {
        if (task.id === task_id) {
          task.sub_tasks.push(sub_task_data);
        }
        return task;
      });
    }
    let updatedTask;
    if (state.taskDetails && task_id && state.taskDetails.id === task_id) {
      updatedTask = JSON.parse(JSON.stringify(state.taskDetails));
      updatedTask.sub_tasks.push(sub_task_data);
    }
    return updatedTask
      ? {
          ...state,
          isLoading: false,
          callback: false,
          taskDetails: JSON.parse(JSON.stringify(updatedTask)),
        }
      : {
          ...state,
          isLoading: false,
          callback: false,
          reloadSubTask: state.reloadSubTask ? !state.reloadSubTask : true,
          tasksList: [...newList],
        };
  }
  return {
    ...state,
    isLoading: false,
    callback: false,
  };
};
export const addSubTaskRequestFailure = (state, action) => {
  const {
    payload: { response },
  } = action;
  if (
    response &&
    response.status === 400 &&
    response.data &&
    response.data.detail &&
    response.data.detail === 'Could not update'
  ) {
    createNotification('error', `Could not add Sub Task`, 5000);
    return {
      ...state,
      isLoading: false,
      callback: false,
      overlap: true,
    };
  }
  if (action.payload.data === undefined) {
    createNotification('error', 'Something went wrong!', 2000);
    return {
      ...state,
      isLoading: false,
      callback: false,
    };
  }
  const {
    payload: { data },
  } = action;
  if (data.status === 400) {
    createNotification('error', 'Failed!! please try again', 2000);
  }
  return {
    ...state,
    isLoading: false,
    callback: false,
  };
};

//edit sub task
export const editSubTaskRequest = (state, action) => {
  return {
    ...state,
    isLoading: false,
    callback: false,
  };
};
export const editSubTaskRequestSuccess = (state, action) => {
  const {
    payload: { data, task_id, sub_task_id },
  } = action;
  if (data && data.status === 200) {
    const sub_task_data = data.data;
    createNotification('success', 'Sub Task updated successfully', 2000);
    let newList = JSON.parse(JSON.stringify(state.tasksList));
    if (state.tasksList && state.tasksList.length > 0 && task_id) {
      newList = newList.map(task => {
        if (task.id === task_id) {
          task.sub_tasks = task.sub_tasks.map(subTask =>
            subTask.id === sub_task_id ? sub_task_data : subTask,
          );
        }
        return task;
      });
    }
    let updatedTask;
    if (state.taskDetails && task_id && state.taskDetails.id === task_id) {
      updatedTask = JSON.parse(JSON.stringify(state.taskDetails));
      updatedTask.sub_tasks = updatedTask.sub_tasks.map(subTask => {
        return subTask.id === sub_task_id ? sub_task_data : subTask;
      });
    }
    return updatedTask
      ? {
          ...state,
          isLoading: false,
          callback: false,
          taskDetails: JSON.parse(JSON.stringify(updatedTask)),
        }
      : {
          ...state,
          isLoading: false,
          callback: false,
          reloadSubTask: state.reloadSubTask ? !state.reloadSubTask : true,
          tasksList: [...newList],
        };
  }
  return {
    ...state,
    isLoading: false,
    callback: false,
  };
};
export const editSubTaskRequestFailure = (state, action) => {
  const {
    payload: { response },
  } = action;
  if (
    response &&
    response.status === 400 &&
    response.data &&
    response.data.detail &&
    response.data.detail === 'Could not update'
  ) {
    createNotification('error', `Could not update`, 5000);
    return {
      ...state,
      isLoading: false,
      callback: false,
      overlap: true,
    };
  }
  if (action.payload.data === undefined) {
    createNotification('error', 'Something went wrong!', 2000);
    return {
      ...state,
      isLoading: false,
      callback: false,
    };
  }
  const {
    payload: { data },
  } = action;
  if (data.status === 400) {
    createNotification('error', 'Failed!! please try again', 2000);
  }
  return {
    ...state,
    isLoading: false,
    callback: false,
  };
};

//delete sub task
export const deleteSubTaskRequest = (state, action) => {
  return {
    ...state,
    isLoading: false,
    callback: false,
  };
};
export const deleteSubTaskRequestSuccess = (state, action) => {
  const {
    payload: { data, task_id, sub_task_id },
  } = action;
  if (data && data.status === 204) {
    createNotification('success', 'Sub Task deleted successfully', 2000);
    let newList = JSON.parse(JSON.stringify(state.tasksList));
    if (state.tasksList && state.tasksList.length > 0 && task_id) {
      newList = newList.map(task => {
        if (task.id === task_id) {
          task.sub_tasks = task.sub_tasks.filter(
            sub_task => sub_task.id != sub_task_id,
          );
        }
        return task;
      });
    }
    let updatedTask;
    if (state.taskDetails && task_id && state.taskDetails.id === task_id) {
      updatedTask = JSON.parse(JSON.stringify(state.taskDetails));
      updatedTask.sub_tasks = updatedTask.sub_tasks.filter(
        sub_task => sub_task.id != sub_task_id,
      );
    }
    return updatedTask
      ? {
          ...state,
          isLoading: false,
          callback: false,
          taskDetails: JSON.parse(JSON.stringify(updatedTask)),
        }
      : {
          ...state,
          isLoading: false,
          callback: false,
          reloadSubTask: state.reloadSubTask ? !state.reloadSubTask : true,
          tasksList: [...newList],
        };
  }
  return {
    ...state,
    isLoading: false,
    callback: false,
  };
};
export const deleteSubTaskRequestFailure = (state, action) => {
  const {
    payload: { response },
  } = action;
  if (
    response &&
    response.status === 400 &&
    response.data &&
    response.data.detail &&
    response.data.detail === 'Could not update'
  ) {
    createNotification('error', `Could not delete Sub Task`, 5000);
    return {
      ...state,
      isLoading: false,
      callback: false,
      overlap: true,
    };
  }
  if (action.payload.data === undefined) {
    createNotification('error', 'Something went wrong!', 2000);
    return {
      ...state,
      isLoading: false,
      callback: false,
    };
  }
  const {
    payload: { data },
  } = action;
  if (data.status === 400) {
    createNotification('error', 'Failed!! please try again', 2000);
  }
  return {
    ...state,
    isLoading: false,
    callback: false,
  };
};

//duplicate task
export const duplicateTaskRequest = (state, action) => {
  return {
    ...state,
    duplicateIsLoading: true,
  };
};
export const duplicateTaskRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data && data.status === 201) {
    createNotification('success', t('task duplicated successfully'), 2000);
    return {
      ...state,
      duplicateIsLoading: false,
      duplicateTaskInfo: data.data,
    };
  }
  return {
    ...state,
    duplicateIsLoading: false,
    duplicateTaskInfo: null,
  };
};
export const duplicateTaskRequestFailure = (state, action) => {
  if (action.payload.data === undefined) {
    createNotification(
      'error',
      'No internet connection found. Please connect to the internet.',
      3000,
    );
    return {
      ...state,
      duplicateIsLoading: false,
      duplicateTaskInfo: null,
    };
  }
  const {
    payload: { data },
  } = action;
  if (data.status === 400) {
    createNotification(
      'error',
      'Sorry! could not duplicate task. Please try again.',
      2000,
    );
  }
  return {
    ...state,
    duplicateIsLoading: false,
    duplicateTaskInfo: null,
  };
};

//DELETE TASK
export const deleteTaskRequest = (state, action) => {
  return {
    ...state,
    deleteIsLoading: true,
    deletedCallback: false,
  };
};
export const deleteTaskRequestSuccess = (state, action) => {
  const {
    payload: { data, task_id },
  } = action;
  if (data && data.status === 204) {
    createNotification('success', t('task deleted successfully'), 3000);

    let newList = JSON.parse(JSON.stringify(state.tasksList));
    if (state.tasksList && state.tasksList.length > 0 && task_id) {
      newList = newList.filter(task => task.id !== task_id);
    }
    return {
      ...state,
      deleteIsLoading: false,
      deletedCallback: true,
      tasksList: [...newList],
    };
  }
  return {
    ...state,
    deleteIsLoading: false,
    deletedCallback: false,
  };
};
export const deleteTaskRequestFailure = (state, action) => {
  createNotification(
    'error',
    t('Could not delete task. Please try again!'),
    3000,
  );
  return {
    ...state,
    deleteIsLoading: false,
    deletedCallback: false,
  };
};

//get task location
export const getTaskLocationsRequest = (state, action) => {
  return {
    ...state,
    createdTaskLocationInfo: null,
    locationListIsLoading: true,
  };
};
export const getTaskLocationsRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    return {
      ...state,
      locationsList: data.data,
      locationListIsLoading: false,
    };
  }
  return {
    ...state,
    locationsList: [],
    locationListIsLoading: false,
  };
};
export const getTaskLocationsRequestFailure = (state, action) => {
  return {
    ...state,
    locationsList: [],
    locationListIsLoading: false,
  };
};

// Add task location
export const addTaskLocationRequest = (state, action) => {
  return {
    ...state,
    createdTaskLocationInfo: null,
    addTaskLocationLoading: true,
  };
};
export const addTaskLocationRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data && data.status === 201) {
    createNotification('success', t('task_location_added_successfully'), 2000);
    const currentList = JSON.parse(JSON.stringify(state.locationsList));
    return {
      ...state,
      addTaskLocationLoading: false,
      createdTaskLocationInfo: data.data,
      locationsList: [data.data, ...currentList],
    };
  }
  return {
    ...state,
    addTaskLocationLoading: false,
    createdTaskLocationInfo: null,
  };
};
export const addTaskLocationRequestFailure = (state, action) => {
  if (action.payload.data === undefined) {
    createNotification(
      'error',
      t('There was an error. Please try again!'),
      3000,
    );
    return {
      ...state,
      addTaskLocationLoading: false,
      createdTaskLocationInfo: null,
    };
  }
  const {
    payload: { data },
  } = action;
  if (data.status === 400) {
    createNotification(
      'error',
      'Sorry! could not add task location. Please try again.',
      2000,
    );
  }
  return {
    ...state,
    addTaskLocationLoading: false,
    createdTaskLocationInfo: null,
  };
};

export const taskUpdateRequestHandler = (state, action) => {
  return {
    ...state,
    isLoading: true,
  };
};
export const taskUpdateRequestSuccessHandler = (state, action) => {
  const {
    payload: { data, task_id },
  } = action;
  if (data && data.status === 200) {
    createNotification('success', t('task_updated_successfully'), 2000);
    const currentList = JSON.parse(JSON.stringify(state.tasksList));
    const newList = currentList.filter(task => task.id !== task_id); // remove task from submitted tasks list
    let updatedTask;
    if (state.taskDetails && task_id && state.taskDetails.id === task_id) {
      updatedTask = JSON.parse(JSON.stringify(state.taskDetails));
      updatedTask.status = data.data.approval_status;
      updatedTask.supervisor_note = data.data.supervisor_note;
      updatedTask.approved_by = data.data.approved_by.id;
    }
    return updatedTask
      ? {
          ...state,
          isLoading: false,
          callback: false,
          taskDetails: JSON.parse(JSON.stringify(updatedTask)),
        }
      : {
          ...state,
          isLoading: false,
          callback: false,
          tasksList: [...newList],
        };
  }
  return {
    ...state,
    isLoading: false,
  };
};
export const taskUpdateRequestFailureHandler = (state, action) => {
  if (action.payload.data === undefined) {
    createNotification(
      'error',
      'Something went wrong! Please try again.',
      3000,
    );
    return {
      ...state,
      isLoading: false,
    };
  }
  const {
    payload: { data },
  } = action;
  if (data.status === 400) {
    createNotification('error', 'Failed!! please try again', 2000);
  }
  return {
    ...state,
    isLoading: false,
  };
};

//get task type
export const getTaskTypeRequest = (state, action) => {
  return {
    ...state,
    taskTypeIsLoading: true,
  };
};
export const getTaskTypeRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    return {
      ...state,
      taskTypeList: data.data,
      taskTypeIsLoading: false,
    };
  }
  return {
    ...state,
    taskTypeList: [],
    taskTypeIsLoading: false,
  };
};
export const getTaskTypeRequestFailure = (state, action) => {
  return {
    ...state,
    taskTypeList: [],
    taskTypeIsLoading: false,
  };
};

// Get master tasks
export const getMasterTasksRequest = (state, action) => ({
  ...state,
  masterTasksLoading: true,
});

export const getMasterTasksRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  return {
    ...state,
    masterTasksLoading: false,
    masterTasksList: data.data,
  };
};

export const getMasterTasksRequestFailure = (state, action) => ({
  ...state,
  masterTasksLoading: false,
  masterTasksList: [],
});

// Edit master task
export const editMasterTaskRequest = (state, action) => ({
  ...state,
  masterTaskEditLoading: true,
});

export const editMasterTaskRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  const updatedList = state.masterTasksList.map(task =>
    task.id === data.data.id ? data.data : task,
  );
  return {
    ...state,
    masterTaskEditLoading: false,
    masterTasksList: updatedList,
  };
};

export const editMasterTaskRequestFailure = (state, action) => {
  createNotification(
    'error',
    action.payload.response.data.detail
      ? t(action.payload.response.data.detail)
      : t('failed_to_edit_master_task'),
    2000,
  );

  return { ...state, masterTaskEditLoading: false };
};

// Get master subtasks
export const getMasterSubTasksRequest = (state, action) => ({
  ...state,
  masterSubTasksLoading: true,
});

export const getMasterSubTasksRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  return {
    ...state,
    masterSubTasksLoading: false,
    masterSubTasksList: data.data,
  };
};

export const getMasterSubTasksRequestFailure = (state, action) => ({
  ...state,
  masterSubTasksLoading: false,
  masterSubTasksList: [],
});

// Edit master subtask
export const editMasterSubTaskRequest = (state, action) => ({
  ...state,
  masterSubTaskEditLoading: true,
});

export const editMasterSubTaskRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  const updatedList = state.masterSubTasksList.map(task =>
    task.id === data.data.id ? data.data : task,
  );
  return {
    ...state,
    masterSubTaskEditLoading: false,
    masterSubTasksList: updatedList,
  };
};

export const editMasterSubTaskRequestFailure = (state, action) => ({
  ...state,
  masterSubTaskEditLoading: false,
});

// Add master subtask
export const addMasterSubTaskRequest = (state, action) => ({
  ...state,
  addMasterSubTaskLoading: true,
});

export const addMasterSubTaskRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  createNotification('success', t('master_subtask_added_successfully'), 2000);
  return {
    ...state,
    addMasterSubTaskLoading: false,
    masterSubTasksList: [...state.masterSubTasksList, data.data],
  };
};

export const addMasterSubTaskRequestFailure = (state, action) => {
  createNotification('error', t('failed_to_add_master_subtask'), 2000);
  return {
    ...state,
    addMasterSubTaskLoading: false,
  };
};

// Get item sub tasks list
export const getItemSubTasksRequest = (state, action) => {
  return {
    ...state,
    isLoadingItemSubTasks: true,
  };
};
export const getItemSubTasksRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    return {
      ...state,
      isLoadingItemSubTasks: false,
      itemSubTasksList: data.data.results,
      itemSubTasksListCount: data.data.count,
      itemSubTasksPageSize: data.data.page_size,
    };
  }
  return {
    ...state,
    isLoadingItemSubTasks: false,
    itemSubTasksList: [],
    itemSubTasksListCount: null,
    itemSubTasksPageSize: null,
  };
};
export const getItemSubTasksRequestFailure = (state, action) => {
  return {
    ...state,
    isLoadingItemSubTasks: false,
    itemSubTasksList: [],
    itemSubTasksListCount: null,
    itemSubTasksPageSize: null,
  };
};

// Sub task approval update
export const subTaskApprovalRequest = (state, action) => {
  return {
    ...state,
    isLoadingSubTaskApproval: true,
  };
};
export const subTaskApprovalRequestSuccess = (state, action) => {
  const {
    payload: { data, sub_task_id },
  } = action;
  if (data && data.status === 200) {
    createNotification('success', t('sub_task_updated_successfully'), 2000);
    const currentList = JSON.parse(JSON.stringify(state.itemSubTasksList));
    const newList = currentList.filter(task => task.id !== sub_task_id);

    return {
      ...state,
      isLoadingSubTaskApproval: false,
      callbackSubTaskApproval: true,
      itemSubTasksList: [...newList],
    };
  }
  return {
    ...state,
    isLoadingSubTaskApproval: false,
    callbackSubTaskApproval: false,
  };
};
export const subTaskApprovalRequestFailure = (state, action) => {
  if (action.payload.data === undefined) {
    createNotification(
      'error',
      'Something went wrong! Please try again.',
      3000,
    );
    return {
      ...state,
      isLoadingSubTaskApproval: false,
      callbackSubTaskApproval: false,
    };
  }
  const {
    payload: { data },
  } = action;
  if (data.status === 400) {
    createNotification('error', 'Failed!! please try again', 2000);
  }
  return {
    ...state,
    isLoadingSubTaskApproval: false,
    callbackSubTaskApproval: false,
  };
};

// clear state on logout
export const handleLogoutRequest = (state, action) => {
  return {
    ...state,
    ...initialState,
  };
};

// Action Handlers
const ACTION_HANDLERS = {
  [GET_TASKS_LIST]: getTasksListRequest,
  [GET_TASKS_LIST_SUCCESS]: getTasksListRequestSuccess,
  [GET_TASKS_LIST_FAILURE]: getTasksListRequestFailure,

  [CREATE_TASK]: createTaskRequest,
  [CREATE_TASK_SUCCESS]: createTaskRequestSuccess,
  [CREATE_TASK_FAILURE]: createTaskRequestFailure,

  [GET_TASK_DETAILS]: getTaskDetailsRequest,
  [GET_TASK_DETAILS_SUCCESS]: getTaskDetailsRequestSuccess,
  [GET_TASK_DETAILS_FAILURE]: getTaskDetailsRequestFailure,

  [EDIT_TASK]: editTaskRequest,
  [EDIT_TASK_SUCCESS]: editTaskRequestSuccess,
  [EDIT_TASK_FAILURE]: editTaskRequestFailure,

  [ADD_SUB_TASK]: addSubTaskRequest,
  [ADD_SUB_TASK_SUCCESS]: addSubTaskRequestSuccess,
  [ADD_SUB_TASK_FAILURE]: addSubTaskRequestFailure,

  [CLEAR_NEW_DEFAULT_SUB_TASK]: handleClearNewDefaultSubTask,

  [ADD_DEFAULT_SUB_TASKS]: addDefaultSubTasksRequest,
  [ADD_DEFAULT_SUB_TASKS_SUCCESS]: addDefaultSubTasksRequestSuccess,
  [ADD_DEFAULT_SUB_TASKS_FAILURE]: addDefaultSubTasksRequestFailure,

  [GET_DEFAULT_SUB_TASKS]: getDefaultSubTasksRequest,
  [GET_DEFAULT_SUB_TASKS_SUCCESS]: getDefaultSubTasksRequestSuccess,
  [GET_DEFAULT_SUB_TASKS_FAILURE]: getDefaultSubTasksRequestFailure,

  [GET_SUB_TASKS]: getSubTasksRequest,
  [GET_SUB_TASKS_SUCCESS]: getSubTasksRequestSuccess,
  [GET_SUB_TASKS_FAILURE]: getSubTasksRequestFailure,

  [GET_SUB_TASK_EVIDENCE]: getSubTaskEvidenceRequest,
  [GET_SUB_TASK_EVIDENCE_SUCCESS]: getSubTaskEvidenceRequestSuccess,
  [GET_SUB_TASK_EVIDENCE_FAILURE]: getSubTaskEvidenceRequestFailure,

  [EDIT_SUB_TASK]: editSubTaskRequest,
  [EDIT_SUB_TASK_SUCCESS]: editSubTaskRequestSuccess,
  [EDIT_SUB_TASK_FAILURE]: editSubTaskRequestFailure,

  [DELETE_SUB_TASK]: deleteSubTaskRequest,
  [DELETE_SUB_TASK_SUCCESS]: deleteSubTaskRequestSuccess,
  [DELETE_SUB_TASK_FAILURE]: deleteSubTaskRequestFailure,

  [DUPLICATE_TASK]: duplicateTaskRequest,
  [DUPLICATE_TASK_SUCCESS]: duplicateTaskRequestSuccess,
  [DUPLICATE_TASK_FAILURE]: duplicateTaskRequestFailure,

  [DELETE_TASK]: deleteTaskRequest,
  [DELETE_TASK_SUCCESS]: deleteTaskRequestSuccess,
  [DELETE_TASK_FAILURE]: deleteTaskRequestFailure,

  [GET_TASK_LOCATIONS]: getTaskLocationsRequest,
  [GET_TASK_LOCATIONS_SUCCESS]: getTaskLocationsRequestSuccess,
  [GET_TASK_LOCATIONS_FAILURE]: getTaskLocationsRequestFailure,

  [ADD_TASK_LOCATION]: addTaskLocationRequest,
  [ADD_TASK_LOCATION_SUCCESS]: addTaskLocationRequestSuccess,
  [ADD_TASK_LOCATION_FAILURE]: addTaskLocationRequestFailure,

  [UPDATE_TASK_STATUS]: taskUpdateRequestHandler,
  [UPDATE_TASK_STATUS_SUCCESS]: taskUpdateRequestSuccessHandler,
  [UPDATE_TASK_STATUS_FAILURE]: taskUpdateRequestFailureHandler,

  [GET_TASK_TYPE]: getTaskTypeRequest,
  [GET_TASK_TYPE_SUCCESS]: getTaskTypeRequestSuccess,
  [GET_TASK_TYPE_FAILURE]: getTaskTypeRequestFailure,

  [GET_MASTER_TASKS]: getMasterTasksRequest,
  [GET_MASTER_TASKS_SUCCESS]: getMasterTasksRequestSuccess,
  [GET_MASTER_TASKS_FAILURE]: getMasterTasksRequestFailure,
  [EDIT_MASTER_TASK]: editMasterTaskRequest,
  [EDIT_MASTER_TASK_SUCCESS]: editMasterTaskRequestSuccess,
  [EDIT_MASTER_TASK_FAILURE]: editMasterTaskRequestFailure,

  [GET_MASTER_SUBTASKS]: getMasterSubTasksRequest,
  [GET_MASTER_SUBTASKS_SUCCESS]: getMasterSubTasksRequestSuccess,
  [GET_MASTER_SUBTASKS_FAILURE]: getMasterSubTasksRequestFailure,

  [ADD_MASTER_SUBTASK]: addMasterSubTaskRequest,
  [ADD_MASTER_SUBTASK_SUCCESS]: addMasterSubTaskRequestSuccess,
  [ADD_MASTER_SUBTASK_FAILURE]: addMasterSubTaskRequestFailure,

  [EDIT_MASTER_SUBTASK]: editMasterSubTaskRequest,
  [EDIT_MASTER_SUBTASK_SUCCESS]: editMasterSubTaskRequestSuccess,
  [EDIT_MASTER_SUBTASK_FAILURE]: editMasterSubTaskRequestFailure,

  [GET_ITEM_SUB_TASKS]: getItemSubTasksRequest,
  [GET_ITEM_SUB_TASKS_SUCCESS]: getItemSubTasksRequestSuccess,
  [GET_ITEM_SUB_TASKS_FAILURE]: getItemSubTasksRequestFailure,

  [UPDATE_SUB_TASK_APPROVAL]: subTaskApprovalRequest,
  [UPDATE_SUB_TASK_APPROVAL_SUCCESS]: subTaskApprovalRequestSuccess,
  [UPDATE_SUB_TASK_APPROVAL_FAILURE]: subTaskApprovalRequestFailure,

  [LOGIN_PROFILE_CREATED_RESET]: handleLogoutRequest,
};

// default initial state
const initialState = {
  // task
  isLoading: false,
  duplicateIsLoading: false,
  deleteIsLoading: false,
  isAddDefaultSubTaskLoading: false,
  newDefaultSubTask: null,
  // location
  locationsList: [],
  locationListIsLoading: false,
  addTaskLocationLoading: false,
  // task type
  taskTypeIsLoading: false,

  callback: false,
  deletedCallback: false,
  subTasksList: [],
  tasksList: [],
  defaultSubTasks: [],
  taskDetails: null,
  createdTaskInfo: null,
  overlap: false,
  duplicateTaskInfo: null,
  locationsList: [],
  createdTaskLocationInfo: null,
  taskTypeList: [],
  reloadSubTask: false,
  // pagination
  tasksListCount: null,
  taskListPageSize: null,
  // master tasks
  masterTasksLoading: false,
  masterTasksList: [],
  masterTaskEditLoading: false,
  // master subtasks
  masterSubTasksLoading: false,
  masterSubTasksList: [],
  masterSubTaskEditLoading: false,
  addMasterSubTaskLoading: false,
  // sub task approval
  isLoadingItemSubTasks: false,
  isLoadingSubTaskApproval: false,
  callbackSubTaskApproval: false,
  itemSubTasksList: [],
  itemSubTasksListCount: null,
  itemSubTasksPageSize: null,
};

export default function tasksReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
